// import Print from "@mui/icons-material/Print";
// import TableRestaurant from "@mui/icons-material/TableRestaurant";
// import { Box, Container, Stack, Tab, Tabs, Typography } from "@mui/material";
// import PropTypes from "prop-types";
// import React from "react";

// function Configurations(props) {
//   const [value, setValue] = React.useState(0);

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   const a11yProps = (index) => {
//     return {
//       id: `simple-tab-${index}`,
//       "aria-controls": `simple-tabpanel-${index}`,
//     };
//   };

//   function TabPanel(props) {
//     const { children, value, index, ...other } = props;

//     return (
//       <div
//         role="tabpanel"
//         hidden={value !== index}
//         id={`simple-tabpanel-${index}`}
//         aria-labelledby={`simple-tab-${index}`}
//         {...other}
//       >
//         {value === index && (
//           <Box className="tab-setting">
//             <Typography>{children}</Typography>
//           </Box>
//         )}
//       </div>
//     );
//   }

//   TabPanel.propTypes = {
//     children: PropTypes.node,
//     index: PropTypes.number.isRequired,
//     value: PropTypes.number.isRequired,
//   };

//   return (
//     <Box p={4}>
//       <Box>
//         <Stack
//           direction="row"
//           alignItems="center"
//           justifyContent="space-between"
//           mb={1}
//           sx={{
//             p: 1,
//           }}
//         >
//           <Typography variant="h5" gutterBottom>
//             Configurations
//           </Typography>
//         </Stack>
//         <Box className="settings-content">
//           <Box sx={{ width: "100%" }}>
//             <Box>
//               <Tabs
//                 variant="scrollable"
//                 scrollButtons="auto"
//                 indicatorColor="primary"
//                 textColor="primary"
//                 value={value}
//                 onChange={handleChange}
//               >
//                 <Tab
//                   className="s-tabs"
//                   iconPosition="start"
//                   label="Categories"
//                   {...a11yProps(0)}
//                 />
//                 <Tab
//                   className="s-tabs"
//                   iconPosition="start"
//                   label="Items"
//                   {...a11yProps(0)}
//                 />
//               </Tabs>
//             </Box>
//             <TabPanel value={value} index={0}>
//               <Box>ddd</Box>
//             </TabPanel>
//             <TabPanel value={value} index={1}>
//               <Box>ddd</Box>
//             </TabPanel>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// }

// export default Configurations;

import React from "react";
import {
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
  Container,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import "./Configurations.css";

const configItems = [
  {
    title: "Categories",
    description: "Manage all your item categories",
    icon: "mdi:folder-outline",
    route: "/app/config/categories",
  },
  {
    title: "Items",
    description: "Add, edit and manage items",
    icon: "mdi:food-outline",
    route: "/app/config/items",
  },
  {
    title: "Attributes & Values",
    description: "Set attributes and values for items",
    icon: "mdi:tune",
    route: "/app/config/attributes-values",
  },
  //   {
  //     title: "Attribute Values",
  //     description: "Manage values for each attribute",
  //     icon: "mdi:format-list-bulleted",
  //     route: "/config/attribute-values",
  //   },
  {
    title: "Addons",
    description: "Create and assign item addons",
    icon: "mdi:plus-circle-outline",
    route: "/app/config/addons",
  },
  {
    title: "Dine Tables",
    description: "Setup and manage dine-in tables",
    icon: "mdi:table-furniture",
    route: "/app/config/dine-tables",
  },
  //   {
  //     title: "Themes",
  //     description: "Customize look & feel",
  //     icon: "mdi:palette-outline",
  //     route: "/config/themes",
  //   },
];

export default function Configurations() {
  const navigate = useNavigate();

  return (
    <Box className="page-content">
      <Container>
        <Box>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={2}
          >
            <Typography variant="h5" gutterBottom>
              Configurations
            </Typography>
          </Stack>
          <Grid container spacing={3}>
            {configItems.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.title}>
                <Card
                  sx={{
                    borderRadius: 3,
                    boxShadow: 3,
                    transition: "0.3s",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: 6,
                    },
                  }}
                  className="config-card"
                >
                  <CardActionArea onClick={() => navigate(item.route)}>
                    <CardContent sx={{ textAlign: "center", p: 3 }}>
                      <Icon
                        icon={item.icon}
                        width={40}
                        height={40}
                        style={{ marginBottom: "12px" }}
                      />
                      <Typography variant="h6" gutterBottom>
                        {item.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {item.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
